import { MapTo } from '@adobe/aem-react-editable-components';
import IconAndText, { IconAndTextEditConfig } from './IconAndText';

export default MapTo('cob-corp-acquisition/components/creditonebank/icon-and-text')(IconAndText, IconAndTextEditConfig);